
import { getSyncNodeIcon } from '../../lib/graphUtils';

export default function ThinkList({
  syncCurrentId,
  syncCurrentNode,
  syncGraph,
  handleDrillDown,
  getDisplayEntityType,
  handleDiscussThinkNode,
  setSelectedNoteId,
  setSelectedAssetId,
  setSelectedInsightId,
  openSyncWorkspace,
  setGlobalSelectedTags,
  setSyncViewMode,
}) {
  const handleOpenNode = (node) => {
    if (node.type === 'tag') {
      setGlobalSelectedTags([node.tagName]);
      setSyncViewMode('list');
    } else if (node.type === 'note' || node.type === 'raw') {
      setSelectedNoteId(node.entityId);
      openSyncWorkspace('notes');
    } else if (node.type === 'asset') {
      setSelectedAssetId(node.entityId);
      openSyncWorkspace('assets');
    } else if (node.type === 'insight') {
      setSelectedInsightId(node.entityId);
      openSyncWorkspace('insights');
    }
  };

  return (
    <div className="flex-1 overflow-y-auto bg-slate-950 p-4 pb-24">
      <div className="mx-auto max-w-2xl space-y-4">
        {syncCurrentId !== 'root' && (
          <div className="mb-6 flex items-center justify-between">
            <h2 className="flex items-center gap-3 text-xl font-bold text-white">
              <span className="text-2xl">{syncCurrentNode.type === 'tag' ? '#' : '📄'}</span>
              {syncCurrentNode.label}
            </h2>
          </div>
        )}

        <div className="grid gap-3">
          {(syncGraph.relations[syncCurrentId] || []).map((childId) => {
            const node = syncGraph.nodesById.get(childId);
            if (!node) return null;
            const hasChildren = (syncGraph.relations[node.id] || []).length > 0 || node.type !== 'raw';
            return (
              <div key={node.id} className="group relative flex w-full flex-col gap-3 rounded-2xl border border-slate-800 bg-slate-900/40 p-4 transition-all hover:border-slate-700 sm:flex-row sm:items-center sm:gap-4">
                <div className="flex min-w-0 gap-3">
                  <button
                    onClick={() => hasChildren && handleDrillDown(node)}
                    className={`z-10 flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-xl text-lg shadow-inner ${
                      node.type === 'tag' ? 'bg-amber-500/10 text-amber-500' :
                      node.type === 'asset' ? 'bg-emerald-500/10 text-emerald-500' :
                      node.type === 'insight' ? 'bg-indigo-500/10 text-indigo-500' :
                      'bg-slate-700/20 text-slate-400'
                    }`}
                  >
                    {getSyncNodeIcon(node.type)}
                  </button>
                  <div className="z-10 min-w-0 flex-1 cursor-pointer" onClick={() => hasChildren && handleDrillDown(node)}>
                    <div className="mb-1 flex min-w-0 items-start justify-between gap-2">
                      <span className="min-w-0 break-words font-bold text-white transition-colors group-hover:text-indigo-300">{node.label}</span>
                      <span className="flex-shrink-0 text-[10px] font-bold uppercase tracking-widest text-slate-600">{getDisplayEntityType(node.type)}</span>
                    </div>
                    <p className="line-clamp-2 break-words text-xs leading-normal text-slate-500">{node.description}</p>
                  </div>
                </div>
                <div className="z-10 flex flex-col shrink-0 gap-2 self-center">
                  <button
                    onClick={() => handleOpenNode(node)}
                    className="flex items-center justify-center gap-1.5 rounded-full border border-slate-700 bg-slate-800 px-3 py-1.5 text-xs font-bold text-slate-300 transition-all hover:bg-slate-700 hover:text-white"
                  >
                    <span>OPEN</span>
                    <svg className="h-3 w-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                    </svg>
                  </button>
                  <button
                    onClick={() => handleDiscussThinkNode(node)}
                    className="flex items-center justify-center gap-1.5 rounded-full border border-indigo-500/30 bg-indigo-500/10 px-3 py-1.5 text-xs font-bold text-indigo-300 transition-all hover:bg-indigo-500/20 hover:text-white"
                  >
                    <span>Sinkで議論</span>
                    <svg className="h-3 w-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                    </svg>
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
